import React from "react";
import { Nav, Tab } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import CurrentEventTabContainer from "../../components/eventManagmentTabs/currentEventTab/currentEventTabContainer";
import PastEventTabContainer from "../../components/eventManagmentTabs/pastEventTab/pastEventTabContainer";
import Constant from "../../util/constant";

const EventListComponent = (props) => {
  /**
   * Retrieves the translation function from the useTranslation hook.
   * Destructures the pageTitle property from the props object.
   * @returns None
   */
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { pageTitle } = props;
  const role = window.localStorage.getItem("role");
  const isClubManager = role === Constant.ROLES.CLUB_MANAGER;
  const clubStaffShell =
    role === Constant.ROLES.CLUB_MANAGER ||
    role === Constant.ROLES.CLUB_EMPLOYEE
      ? " club-staff-page-shell"
      : "";

  return (
    <React.Fragment>
      <Helmet>
        <title>Event Management | RizzTix </title>
      </Helmet>
      <div className={`pageContent eventManagement${clubStaffShell}`}>
        <div className="events">
          <Breadcrumbs
            innerPagetitle={t("EVENTS_LIST")}
            breadcrumbItem={t("EVENTS")}
            pageTitle={pageTitle}
            BreadcrumbInner={true}
            BreadcrumbmainTitle={true}
          />
          <Card className="mb-0 cardMain">
            <div className="listTabStyle">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="currentEvents"
              >
                <div className="events-tab-bar">
                  <Nav variant="pills" className="flex-row">
                    <Nav.Item>
                      <Nav.Link eventKey="currentEvents">
                        {t("CURRENT_EVENTS")}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="pastEvents">
                        {t("PAST_EVENTS")}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  {isClubManager && (
                    <button
                      type="button"
                      className="btn btn-primary fillButton events-tab-add-btn"
                      onClick={() =>
                        navigate("/events-list/add-event", {
                          state: { page: "add" },
                        })
                      }
                    >
                      <i className="bx bxs-plus-circle"></i>
                      {t("ADD_EVENT")}
                    </button>
                  )}
                </div>
                <Tab.Content>
                  <Tab.Pane eventKey="currentEvents">
                    <CurrentEventTabContainer />
                  </Tab.Pane>
                  <Tab.Pane eventKey="pastEvents">
                    <PastEventTabContainer />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EventListComponent;
